/**
 * jQuery をグローバルへ載せる。
 *
 * jquery.cookie や bootstrap 3 は「グローバルの jQuery」を参照する jQuery プラグイン
 * なので、プラグインを import する前にこの module を import しておく必要がある。
 * ESM の import は宣言順に評価されるため、プラグインより前に書けば順序は保証される。
 * (CommonJS 時代は require の実行順で担保していた)
 *
 * Blade のインラインスクリプトも `$(...)` を直接使うため、window への代入は必須。
 */
import jQuery from 'jquery'

window.$ = window.jQuery = jQuery

export default jQuery
